import React from 'react';

const DAYS_FULL_PT = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];
const MONTHS_PT = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

function formatDateLong(dateStr) {
    if (!dateStr) return '';
    const [y, m, d] = dateStr.split('-').map(Number);
    const dt = new Date(y, m - 1, d);
    const dayName = DAYS_FULL_PT[dt.getDay()];
    return `${dayName.charAt(0).toUpperCase() + dayName.slice(1)}, ${d} de ${MONTHS_PT[m - 1]} de ${y}`;
}

/**
 * TimeSlotGrid — grid 3 colunas de horários disponíveis.
 */
function TimeSlotGrid({ slots, selectedTime, onSelect }) {
    return (
        <div className="ps-slots">
            {slots.map(slot => {
                let cls = 'ps-slot';
                if (!slot.available) cls += ' ps-slot--unavailable';
                else if (slot.time === selectedTime) cls += ' ps-slot--selected';
                return (
                    <button
                        key={slot.time}
                        className={cls}
                        onClick={() => slot.available && onSelect(slot.time)}
                        disabled={!slot.available}
                        type="button"
                    >
                        {slot.time}
                    </button>
                );
            })}
        </div>
    );
}

/**
 * StepTime — Step 3
 * Seleção de horário com grid 3 colunas e info de fuso horário.
 */
export default function StepTime({ date, slots, slotsLoading, selectedTime, onSelect, onNext, onBack, nextLabel, renderActions }) {
    return (
        <div className="ps-step-content">
            <h2 className="ps-step-title">Escolha o horário</h2>
            <p className="ps-step-subtitle">{formatDateLong(date)}</p>

            {slotsLoading && (
                <div className="ps-slots-loading">
                    <div className="ps-spinner" />
                    <span>Carregando horários...</span>
                </div>
            )}

            {!slotsLoading && slots.length === 0 && (
                <div className="ps-empty-state">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ddd" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    <p>Nenhum horário disponível para esta data.</p>
                    <p className="ps-empty-state__hint">Tente selecionar outra data.</p>
                </div>
            )}

            {!slotsLoading && slots.length > 0 && (
                <TimeSlotGrid slots={slots} selectedTime={selectedTime} onSelect={onSelect} />
            )}

            {/* Info fuso horário */}
            <div className="ps-info-card">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ED3680" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                </svg>
                <span>Horários exibidos no fuso horário de Brasília (GMT-3).</span>
            </div>

            {renderActions ? renderActions({ selectedTime, onBack }) : (
                <div className="ps-actions">
                    <button className="ps-btn ps-btn--secondary" onClick={onBack}>
                        ← Voltar
                    </button>
                    <button
                        className="ps-btn ps-btn--primary"
                        disabled={!selectedTime}
                        onClick={onNext}
                    >
                        {nextLabel || 'Continuar'}
                    </button>
                </div>
            )}

            <p className="ps-trust-note">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                Seus dados estão protegidos
            </p>
        </div>
    );
}
